// extracted by mini-css-extract-plugin
module.exports = {"ordersTab":"Orders_ordersTab__MH7HT"};